import React from 'react'
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Container from '../components/container'
import { getEntityUrl} from '../lib/helpers'

import * as styles from './article-header-infinite.module.css'


function Breadcrumb (props) {
    return (
      <div className={styles.breadcrumb}>
          <span>
              <Link className={styles.breadcrumb_link} to="/">Home</Link> 
              { // show site_section as long as no parent
                !props.thisPage.parent?.slug && props.thisPage.site_section?.slug && (<> &gt; <Link className={styles.breadcrumb_link} to={`/${props.thisPage.site_section?.slug}/`}>{props.thisPage.site_section?.section}</Link> </>)}
              { props.thisPage.parent?.slug && (<> &gt; <Link className={styles.breadcrumb_link} to={`/${props.thisPage.parent?.slug}/`}>{props.thisPage.parent.title_short ? props.thisPage.parent.title_short : props.thisPage.parent?.title}</Link> </>)}
              { props.thisPage?.primary_topic && (<> &gt; {props.thisPage?.primary_topic}</>)}
          </span>
      </div>
    )
  }


export default function ArticleHeader(props) {
    const article = props.article
    
    // author spacing
    var author_spacer = ""
    var author_spacer_last = ""
    if(article.authors.length == 2){
        author_spacer_last = " and "
    } else if (article.authors.length > 2) {
        author_spacer = ", "
        author_spacer_last = ", and "
    }

    // updated date
    //var today = moment().startOf('day');
    //var updated_days = Math.round((today - moment(article.updated_at)) / 86400000);
    var updated_days = 1;
    // moment(article.updated_at).fromNow()
    var updated_at_fromnow = "1 day ago";
    // moment(article.updated_at).format('MMMM YYYY')
    var updated_at_date = "January 2020";

    return (
        <>
            <div className={styles.pageHeader}>
                <Container>
                    <Breadcrumb thisPage={article}></Breadcrumb>
                    <h1 className={styles.title}>{article.title}</h1>
                    { article.excerpt && 
                        <span>{article.excerpt}</span>
                    }
                </Container>
            </div>
            
            <div className={styles.pageSubHeader}>
                {article.authors && article.authors.length>0 &&
                    
                    <div className={styles.authors}>
                        <div className={styles.avatars}>
                        {article.authors.map(entity => (
                            <>
                                {entity.main_image &&
                                    <span key={entity._id} className={styles.avatar}>
                                        <GatsbyImage className={styles.avatarImg} image={getImage(entity?.main_image?.imageFile)} alt={entity.main_image.alternativeText ? entity.main_image.alternativeText : "a nice image" } />
                                    </span>
                                }
                            </>
                        ))}
                        </div>
                        <div className={styles.mediaBody}>
                            By {article.authors.map((entity, index) => (
                                <>
                                    <Link key={entity._id} to={getEntityUrl(entity)}>{entity.name}</Link>
                                    { index<(article.authors.length-2) ? author_spacer:""}
                                    { index==(article.authors.length-2) ? author_spacer_last:""}
                                </>
                            ))}
                            <small className={styles.dateBlock}>
                                { updated_days > 365 ? "First published more than 1 year ago." : ""}
                                { updated_days < 30 ? "Last updated " + updated_at_fromnow + ".": "" }
                                { (updated_days >= 30) & (updated_days <= 365) ? "Last updated in " + updated_at_date +"." : "" }
                            </small>
                        </div>
                    </div>
                }
                { (!article.authors || (article.authors && article.authors.length==0)) &&
                    <small className={styles.dateBlock}>
                        { updated_days > 365 ? "First published more than 1 year ago." : ""}
                        { updated_days < 30 ? "Last updated " + updated_at_fromnow + ".": "" }
                        { (updated_days >= 30) & (updated_days <= 365) ? "Last updated in " + updated_at_date +"." : "" }
                    </small>
                }
                {article.authorities && article.authorities>0 && 
                    <ul>
                        {article.authorities.map(entity => (
                            <li key={entity._id}>
                                <Link to={getEntityUrl(entity)}>{entity.name}</Link>
                            </li>
                        ))}
                    </ul>
                }
            </div>
        
        </>
    )
  }